"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModalBody", {
    enumerable: true,
    get: function() {
        return ModalBody;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _ModalContext = require("../ModalContext");
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ModalBody = (param)=>{
    let { children, noPadding = false, noMargin = false, onScrolledToBottom } = param;
    const { isAdmin, spacers: { s5, s6 } } = (0, _Theme.useTheme)();
    const { scrollable, headerBorder, setStickyHeader, setStickyFooter, modalBodyRef, withFooter } = (0, _react.useContext)(_ModalContext.ModalContext);
    const noBorderStyle = isAdmin && !headerBorder ? "0" : s5;
    const handleModalScroll = (0, _react.useCallback)(()=>{
        if (!isAdmin || (modalBodyRef === null || modalBodyRef === void 0 ? void 0 : modalBodyRef.current) == null || !scrollable) {
            return;
        }
        const { scrollTop, clientHeight, scrollHeight } = modalBodyRef.current;
        const heightDelta = scrollHeight - clientHeight;
        const scrollBottom = heightDelta - scrollTop;
        const scrollMarginLow = 10;
        const scrollMarginHigh = 20;
        const deltaHeightMargin = 200;
        if (scrollTop < scrollMarginLow) {
            setStickyHeader(false);
        } else if (scrollTop > scrollMarginHigh && heightDelta > deltaHeightMargin) {
            setStickyHeader(true);
        }
        if (scrollBottom < scrollMarginLow) {
            setStickyFooter(false);
            onScrolledToBottom === null || onScrolledToBottom === void 0 ? void 0 : onScrolledToBottom();
        } else if (scrollBottom > scrollMarginHigh && heightDelta > deltaHeightMargin) {
            setStickyFooter(true);
        }
    }, [
        isAdmin,
        modalBodyRef,
        onScrolledToBottom,
        scrollable,
        setStickyFooter,
        setStickyHeader
    ]);
    (0, _react.useEffect)(()=>{
        const ref = modalBodyRef === null || modalBodyRef === void 0 ? void 0 : modalBodyRef.current;
        ref === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", handleModalScroll, {
            passive: true
        });
        return ()=>ref === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", handleModalScroll);
    }, [
        handleModalScroll,
        modalBodyRef
    ]);
    return /*#__PURE__*/ _react.default.createElement("div", {
        ref: modalBodyRef,
        className: _style.default.dynamic([
            [
                "5e5e19aa57fd08f1",
                [
                    noPadding ? 0 : "0 ".concat(s6, " ").concat(withFooter ? 0 : "2rem"),
                    noMargin ? "0" : noBorderStyle,
                    scrollable ? "auto" : "visible"
                ]
            ]
        ]) + " " + "modal-body"
    }, children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "5e5e19aa57fd08f1",
        dynamic: [
            noPadding ? 0 : "0 ".concat(s6, " ").concat(withFooter ? 0 : "2rem"),
            noMargin ? "0" : noBorderStyle,
            scrollable ? "auto" : "visible"
        ]
    }, "div.__jsx-style-dynamic-selector{padding:".concat(noPadding ? 0 : "0 ".concat(s6, " ").concat(withFooter ? 0 : "2rem"), ";margin:").concat(noMargin ? "0" : noBorderStyle, " 0 0 0;overflow:").concat(scrollable ? "auto" : "visible", ";height:100%;word-break:break-word;-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1}")));
};

//# sourceMappingURL=ModalBody.js.map